<template lang="pug">
#select-laudo(v-loading='tipos.length == 0')
    p(v-if='tipos.length > 1') {{ $t('mensagens.laudos.selecioneTipoDeLaudo') }}
    el-select(v-if='tipos.length > 1',
        v-model='laudoSelecionado',
        :placeholder="$t('mensagens.laudos.selecioneTipoDeLaudo')",
        @change='mudarLaudo',
        style="width: 70%"
    )
        el-option(
            v-for='tipo in tipos',
            :key='tipo.id',
            :label='traduzirNomeLaudo(tipo.nome)',
            :value='tipo.id'
        )
</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import { mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import { orderBy } from 'lodash';
import tradutorDeLaudos from '@/utils/tradutorDeLaudos';

const laudos = [
    { id: 99, nomeComponent: 'LaudoGeralModal'},
    { id: 1, nomeComponent: 'LaudoAgricolaModal' },
    { id: 2, nomeComponent: 'LaudoBacenFiscalizacaoModal' },
    { id: 3, nomeComponent: 'LaudoBenfeitoriasModal' },
    { id: 4, nomeComponent: 'LaudoConformidadeAmbientalModal' },
    { id: 5, nomeComponent: 'LaudoCarbonoModal' },
    { id: 6, nomeComponent: 'LaudoHistoricoAgricolaModal' },
    { id: 7, nomeComponent: 'LaudoDiagnosticoAgricolaModal' },
    { id: 8, nomeComponent: 'LaudoSupressaoVegetalModal' },
    { id: 9, nomeComponent: 'LaudoTecnicoAgricolaModal' },
    { id: 10, nomeComponent: 'LaudoCroquiModal' },
    { id: 11, nomeComponent: 'LaudoBacenResolucao140Modal' },
    { id: 12, nomeComponent: 'LaudoAvaliacaoFundiariasModal' },
    { id: 13, nomeComponent: 'LaudoAvaliacaoAreaProdutivaModal' },
    { id: 14, nomeComponent: 'LaudoAvaliacaoSocioambientalModal' },
    { id: 15, nomeComponent: 'LaudoRenovabioModal' },
    { id: 16, nomeComponent: 'LaudoRelatorioTerritorialModal' },
    { id: 17, nomeComponent: 'LaudoAnaliseCoberturaSoloModal'},
    { id: 18, nomeComponent: 'LaudoMutPastagemModal'}
];

export default {
    name: 'SelecionarLaudo',

    emits: ['laudoUnico'],

    props: {
        laudoId: {
            type: Number
        }
    },

    data() {
        return {
            tipos: [],
            laudoSelecionado: null
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        traduzirNomeLaudo(laudo) {
            return tradutorDeLaudos.traduzirLaudo(laudo);
        },

        async getTipoLaudo() {
            try {
                const response = await LaudoEmpresaService.buscarLaudosPorEmpresa(this.usuarioLogado.idGrupo);
                this.tipos = response.data.itens;
                if (!this.tipos || this.tipos.length === 0 || this.usuarioLogado.isAnalyst) {
                    const response2 = await LaudoEmpresaService.buscarTiposLaudo();
                    this.tipos = response2.data.itens;
                }
                this.tipos = orderBy(this.tipos, ['nome']);

                this.$emit('laudoUnico', this.tipos.length > 1 ? 'false' : 'true');
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.ocorreuUmerroAoBuscarTiposDeLaudo')
                });
            }
            if (this.laudoId && this.laudoId !== 99) {
                this.laudoSelecionado = this.laudoId;
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            } else if (this.laudoId === 99) {
                this.laudoSelecionado = 99;
                this.tipos.unshift({
                    codigo: 'VAZIO',
                    id: 99,
                    nome: 'Selecione'
                });
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            } else {
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.laudoSelecionado = route.id;
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            }
        },

        mudarLaudo() {
            this.tipos = this.tipos.filter(tipo => tipo.id !== 99);
            const route = laudos.find(r => r.id === this.laudoSelecionado);
            this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
        }
    },
    async mounted() {
        await this.getTipoLaudo();
    },
    watch: {
        laudoId() {
            this.laudoSelecionado = this.laudoId;
            const route = laudos.find(r => r.id === this.laudoSelecionado);
            this.$emit('nomeComponenteSelecionado', route.nomeComponent);
        }
    }
};
</script>

<style scoped lang="scss">
#select-laudo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    min-height: 77px;

    .el-select {
        min-width: 350px;
    }
}
</style>
